import { LogErrorInterface } from '@/interfaces';
import { getSession } from 'next-auth/react';

import axios from 'axios';

export const axiosLogger = axios.create({
	baseURL: process.env.NEXT_PUBLIC_API,
	headers: {
		'Content-Type': 'application/json',
	},
});

const safeJsonParse = (value: any) => {
	try {
		return typeof value === 'string' ? JSON.parse(value) : value;
	} catch {
		return {};
	}
};

export const logApiError = async (error: any) => {
	try {
		const session = await getSession();
		const data: LogErrorInterface = {
			code: error?.response?.status ?? 400,
			description: error?.message ?? 'No description',
			payload: error?.config?.data ? safeJsonParse(error.config.data) : {},
			url: error?.config?.url ?? 'No url',
			user_id: session?.user?.user?.id ?? '',
		};

		if (data.description === 'Network Error') return;
		await axiosLogger.post('/commons/log-error', data);
	} catch (e) {
		console.warn('Error logging API error', e);
	}
};
